import React from "react";
import NavBar from '../components/navbar';
import { useAuth0 } from '@auth0/auth0-react';
import { Grid, Button } from '@material-ui/core'
import { makeStyles, withStyles } from '@material-ui/styles'

const ColorButton = withStyles((theme) => ({
  root: {
    color: 'white',
    backgroundColor: '#153BAB',
    width: '270px',
    height: '45px',
    borderRadius: '10px',
    marginLeft: '15px',
    marginTop: '30px',
    marginBottom: '30px',
    '&:hover': {
    backgroundColor: '#294780',
    },
  },
}))(Button);

const useStyles = makeStyles((theme) => ({
  root: {
    marginLeft: '15px',
    paddingRight: '30px'
  },
  title: {
    marginTop: '50px', 
    marginLeft: '10px'
  },
  num: {
    color: '#E98030', 
    marginRight: '10px'
  },
  grey: {
    color: '#414041'
  },
  blue: {
    color: '#153BAB'
  }
})) 

const Item = ({ children }) => {
  return(
    <Grid item xs={10} lg={4} md={5}>
      { children }
    </Grid>
  )
}

const GreySpan = ({ children }) => {
  const classes = useStyles();
  return <span className={classes.grey}>{ children }</span>
}

const BlueSpan = ({ children }) => {
  const classes = useStyles();
  return <span className={classes.blue}>{ children }</span>
}

const OrangeSpan = ({ children }) => {
  const classes = useStyles();
  return <span className={classes.num}>{ children }</span>
}

const TalentPresignupPage = (props) => {
  const classes = useStyles();
  const { loginWithRedirect } = useAuth0();
  return (
    <>
      <NavBar type='main' />
      <Grid 
      container 
      direction="row"
      justify="flex-start"
      alignItems="center"
      spacing={5}
      className={classes.root}
      >
        <Grid item xs={10} className={classes.title}>
          <h2>
            <strong>
              <GreySpan>Work with remote </GreySpan>
              <BlueSpan> AI Teams NOW</BlueSpan>
            </strong>
          </h2>
        </Grid>
        <Item>
          <h3>
            <strong>
              <OrangeSpan>1 </OrangeSpan>
              <GreySpan> Assess your </GreySpan>
              <BlueSpan>skills</BlueSpan>
            </strong>
          </h3>
          <h5 className={classes.grey}>
          Want to be among the greats in the AI field? Assess your skills by going through the Lyra assessment.
          </h5>
        </Item>
        <Item>
          <h3>
            <strong>
              <OrangeSpan>2 </OrangeSpan>
              <GreySpan> Join </GreySpan>
              <BlueSpan>Talent Network</BlueSpan>
            </strong>
          </h3>
          <h5 className={classes.grey}>
          Become a part of something bigger. Get vetted and join the TOP AI Talent network in Africa.
          </h5>
        </Item>
        <Item>
          <h3>
            <strong>
              <OrangeSpan>3 </OrangeSpan>
              <GreySpan> Work With </GreySpan>
              <BlueSpan>Remote Teams</BlueSpan>
            </strong>
          </h3>
          <h5 className={classes.grey}>
          Become a part of something bigger. Get vetted and join the TOP AI Talent network in Africa.
          </h5>
        </Item>
        <Item>
          <h3>
            <strong>
              <OrangeSpan>4 </OrangeSpan>
              <GreySpan> Upskill</GreySpan>
              <BlueSpan>&nbsp;& get upskilled</BlueSpan>
            </strong>
          </h3>
          <h5 className={classes.grey}>
          Learn from the best. Lyra works with experts from the region to provide educational and upskilling programs for everyone. 
          </h5>
        </Item>
        <Item>
          <h3>
            <strong>
              <OrangeSpan>5 </OrangeSpan>
              <GreySpan> Work on frontier </GreySpan>
              <BlueSpan>research projects</BlueSpan>
            </strong>
          </h3>
          <h5 className={classes.grey}>
          Work with the top ML experts on State of the Art research projects.
          </h5>
        </Item>
      </Grid>
      <Grid 
      container 
      direction="row"
      justify="flex-start"
      alignItems="center"
      className={classes.root}
      >
        <ColorButton onClick={ loginWithRedirect }>
          Join the Talent Network
        </ColorButton>
      </Grid>
      
    </>
  );
}


export default TalentPresignupPage;
